"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const castArray = require("./lib/castArray.cjs");
const RENAMED_PARAMS = {
  accessToken: "access_token"
};
const castOrderingToString = (ordering) => typeof ordering === "string" ? ordering : [
  ordering.field,
  ordering.direction === "desc" ? ordering.direction : void 0
].filter(Boolean).join(" ");
const buildQueryURL = (endpoint, args) => {
  const { predicates, ...params } = args;
  const url = new URL(`documents/search`, `${endpoint}/`);
  if (predicates) {
    for (const predicate of castArray.castArray(predicates)) {
      url.searchParams.append("q", `[${predicate}]`);
    }
  }
  for (const k in params) {
    const name = RENAMED_PARAMS[k] ?? k;
    let value = params[k];
    if (name === "orderings") {
      const scopedValue = params[name];
      if (scopedValue != null) {
        const v = castArray.castArray(scopedValue).map((ordering) => castOrderingToString(ordering)).join(",");
        value = `[${v}]`;
      }
    } else if (name === "routes") {
      if (typeof params[name] === "object") {
        value = JSON.stringify(castArray.castArray(params[name]));
      }
    }
    if (value != null) {
      url.searchParams.set(name, castArray.castArray(value).join(","));
    }
  }
  return url.toString();
};
exports.buildQueryURL = buildQueryURL;
//# sourceMappingURL=buildQueryURL.cjs.map
